module.exports = __webpack_public_path__ + "img/13.f99ce0e2.jpg";